import React, {useState} from 'react';
import styled from 'styled-components';
import DelegateItem from './DelegateItem';
import {labels, currentResource} from '../../../../../common/utils/utils';
import ConfirmationModal from '../../../../../common/components/ConfirmationModal/confirmationModal';
import {MotifTooltip, MotifIcon} from '@common/MotifWrapperComponents/motifCompat';
import {IconoirTrash} from '@ey-xd/motif-icon';

const ViewDelegate = (props) => {
	const {activeTab, users, removeDelegate, noDelegationMessage} = props;
	const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
	const [userToRemove, setUserToRemove] = useState(false);
	const [hideTooltip, setHideTooltip] = useState(false);

	const onRemoveClick = (removeUser) => {
		setUserToRemove(removeUser);
		setShowDeleteConfirmation(true);
	};

	return (
		<StyledSection className="styledSectionWrapper" {...props}>
			{users.length > 0 ? (
				users.map((user, index) => {
					return (
						<section className="delegate-item" key={user.userId}>
							<DelegateItem activeTab={activeTab} user={user} className={index + 1 !== users.length ? 'bottom-border-zero' : ''} />
							{activeTab === '1' ? (
								<MotifTooltip
									id={`remove-${user.userId}`}
									trigger={
										<span
											onClick={() => {
												setHideTooltip(true);
												onRemoveClick(user);
											}}
											className="remove-delegate-button"
										>
											<MotifIcon src={IconoirTrash} />
										</span>
									}
									placement="right"
									variant="alt"
									contentClassName="hideTooltipClose"
									hideCloseButton
									hide={hideTooltip}
								>
									{labels.remove}
								</MotifTooltip>
							) : (
								''
							)}
						</section>
					);
				})
			) : (
				<section className="no-delegation-message">{noDelegationMessage}</section>
			)}
			<ConfirmationModal
				show={showDeleteConfirmation}
				showButtons
				title={labels.removeDelegateTitle}
				description={labels.removeDelegateMessgae}
				bodyText={`${labels.delegate}:`}
				bodyTextValue={`${userToRemove.firstName} ${userToRemove.lastName}`}
				confirmBtnTitle={labels.remove}
				cancelBtnTitle={labels.cancel}
				onConfirmClick={() => {
					removeDelegate(userToRemove);
					setShowDeleteConfirmation(false);
					setHideTooltip(false);
				}}
				onHide={() => {
					setShowDeleteConfirmation(false);
					setHideTooltip(false);
				}}
				closeTitle={currentResource.common.close}
				modalsize="small"
			/>
		</StyledSection>
	);
};

export default ViewDelegate;

const StyledSection = styled.section`
	display: flex;
	flex-flow: column;
	gap: var(--px-8);
	height: 100%;
	width: 100%;
	.no-delegation-message {
		font-size: var(--px-14);
		color: var(--neutrals-700);
	}
	.delegate-item {
		flex-flow: row;
		display: flex;
		border-bottom: var(--px-1) solid var(--neutrals-200);
	}
	.remove-delegate-button {
		margin: 0 0 0 var(--px-10);
		display: flex;
		align-items: center;
		justify-content: flex-start;
		svg {
			fill: var(--neutrals-900);
			width: var(--px-20);
			height: var(--px-20);
		}
	}
	.motif-tooltip-wrapper {
		display: flex;
	}
`;
